import { ApiDomains } from '@cf/api-v2-types';
import { simpleCreateMutation, simpleCreateQuery } from '$lib/utils/simpleQueryMutations';
import type { DomainParameters } from '@cf/api-v2-types';


export const useDomainsReadQuery = () => {
    return simpleCreateMutation(async (data: DomainParameters ) => {
		const apiDomains = new ApiDomains('/proxy');
        return apiDomains.read(data);
	});
};

export const useDomainsReadDetailsQuery = (id: string) => {
	return simpleCreateMutation( async (id: string) => {
		const apiDomains = new ApiDomains('/proxy');
		return apiDomains.readOne(id);
	});
};

export const useDomainsCreateMutation = () => {
	return simpleCreateMutation<any>(async (data: unknown) => {
		const apiDomains = new ApiDomains('/proxy');

		const result = await apiDomains.create(data);
		return result;
	});
};

export const useDomainsUpdateMutation = () => {
	return simpleCreateMutation<{
		id: string;
		data: unknown;
	}>(async (options) => {
		const apiDomains = new ApiDomains('/proxy');
		const result = await apiDomains.update(options.id, options.data);
		return result;
	});
};

export const useDeleteScreenshotMutation = () => {
	return simpleCreateMutation<{
		id: string;
		data: unknown;
	}>(async (options) => {
		const apiDomains = new ApiDomains('/proxy');
		const result = await apiDomains.deleteImage(options.id, options.data);
		return result;
	});
};

export const useDomainsScreenshortUploadMutation = () => {
	return simpleCreateMutation<{
		id: string;
		data: unknown;
	}>(async (options) => {
		const apiDomains = new ApiDomains('/proxy');
		const result = await apiDomains.upload(options.id, options.data);
		return result;
	});
};

export const useDomainsRemoveMutation = () => {
	return simpleCreateMutation<{
		id: string;
	}>(async (options) => {
		const apiDomains = new ApiDomains('/proxy');

		const result = await apiDomains.remove(options.id);
		return result;
	});
};

export const useDomainsCloneMutation = () => {
	return simpleCreateMutation<{
		data: unknown;
	}>(async (options) => {
		const apiDomains = new ApiDomains('/proxy');

		const result = await apiDomains.clone(options.data);
		return result;
	});
};

export const useDomainsExportMutation = () => {
	return simpleCreateMutation<{
		data: {data: {domain_id: string[], search_string: string}};
	}>(async (options) => {
		const apiDomains = new ApiDomains('/proxy');

		const result = await apiDomains.export(options.data);
		return result;
	});
};


export const useChangeDomainsStatusMutation = () => {
	return simpleCreateMutation<{
		id: string;
		data: {status: string};
	}>(async (options) => {
		const apiDomains = new ApiDomains('/proxy');

		const result = await apiDomains.domainStatus(options.id, options.data);
		return result;
	});
};

